import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { Main } from '@/app/ui/components/main';
import { ChatType } from '@/app/utils/constants';
import AIChatProvider from '@/app/components/features/aiChat/AIChatContext';
import useEntryChat from '@/app/components/features/aiChat/hooks/useEntryChat';
import { Sidechat } from '@/app/components/shared/Sidechat';
import { Spinner } from '@/app/ui/components/spinner';
import { getBidDetailsQuery } from '@/app/hooks/queries/useBids';
import { getTenderPackageDetailsQuery } from '@/app/hooks/queries/useTenderPackages';
import { useSuspenseQuery } from '@tanstack/react-query';
import { VersionHistoryPanel } from '@/app/components/features/evaluations/VersionHistoryPanel/VersionHistoryPanel';

export const Route = createFileRoute(
  '/_authed/project/$projectId/_layout/(evaluation)/tender-packages/$tenderPackageId/bids/$bidId/_layout',
)({
  component: RouteComponent,
  loader: async (opts) => {
    const [bid, evaluation] = await Promise.all([
      opts.context.queryClient.ensureQueryData(getBidDetailsQuery(opts.params.bidId)),
      opts.context.queryClient.ensureQueryData(
        getTenderPackageDetailsQuery(opts.params.tenderPackageId),
      ),
    ]);
    if (!bid || !evaluation) throw notFound();
  },
  pendingComponent: () => (
    <Main className="relative">
      <Spinner kind="inset" />
    </Main>
  ),
});

function RouteComponent() {
  const { bidId } = Route.useParams();
  const { data: bid } = useSuspenseQuery(getBidDetailsQuery(bidId));

  const stream = useEntryChat({
    id: bidId,
    namespace: ChatType.BID,
  });

  return (
    <AIChatProvider
      chatType={ChatType.BID}
      sourceStream={stream}
      chatInitialOpen={false}
      evaluationName={bid.bidAdditionalName || bid.companyName}
    >
      <Main>
        <Outlet />
      </Main>
      <VersionHistoryPanel evalId={bidId} />
      <Sidechat />
    </AIChatProvider>
  );
}
